import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=5c5a4e3a&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5a4e3a')) {
      api.createRecord('5c5a4e3a', component.options)
    } else {
      api.reload('5c5a4e3a', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=5c5a4e3a&", function () {
      api.rerender('5c5a4e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/formioTemplates/vistas/Templates.vue"
export default component.exports